import React, { useContext, useEffect, useRef, useState } from 'react'
import { getSSLExpiration } from '../../services/domainCertificateServices';
import { ThemeContext } from '../../layout/BaseLayout';
import { Loader } from '../../utils/loader';
import NoDataError from '../../components/NoDataError';
import moment from 'moment';

const DomainCertificate = () => {

    let toast = useContext(ThemeContext);
    const [sslcertificateList, setSslcertificateList] = useState({});
    const [filteredSslCertificateList, setFilteredSslCertificateList] = useState({});
    const [isLoader, setIsLoader] = useState(false);
    const [selectedDomainName, setSelectedDomainName] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");

    const getListOfsslCertificate = () => {
        setIsLoader(true);
        getSSLExpiration().then((res) => {
            if (res.isSuccess) {
                const groupByOperatorId = res?.data?.reduce((groups, item) => {
                    const opCode = item?.operatorId;
                    if (!groups[opCode]) {
                        groups[opCode] = [];
                    }
                    groups[opCode].push(item);
                    return groups;
                }, {});
                setSslcertificateList(groupByOperatorId);
                setFilteredSslCertificateList(groupByOperatorId);
            } else {
                toast.error(res?.execption?.message)
            }
            setIsLoader(false);
        }).catch(e => {
            setIsLoader(false);
        })
    }

    // useEffect(() => {
    //     let fullList = { ...sslcertificateList };
    //     if (!!selectedDomainName) {
    //         const filteredList = Object.keys(sslcertificateList).filter(key => selectedDomainName.includes(key)).reduce((result, key) => {
    //             result[key] = sslcertificateList[key];
    //             return result;
    //         }, {});
    //         setFilteredSslCertificateList(filteredList);
    //     } else {
    //         setFilteredSslCertificateList(fullList);
    //     }
    // }, [selectedDomainName])

    // useEffect(() => {
    //     let fullList = { ...sslcertificateList };
    //     if (!!selectedMonth) {
    //         const filteredByDate = Object.keys(sslcertificateList).reduce((result, key) => {
    //             const filteredItems = sslcertificateList[key].filter(item => {
    //                 if (item.expiry) {
    //                     const expiryDate = new Date(item.expiry);
    //                     return expiryDate.getMonth() + 1 == selectedMonth;
    //                 }
    //                 return false;
    //             });
    //             if (filteredItems.length > 0) {
    //                 result[key] = filteredItems;
    //             }
    //             return result;
    //         }, {});
    //         setFilteredSslCertificateList(filteredByDate)
    //     } else {
    //         setFilteredSslCertificateList(fullList)
    //     }
    // }, [selectedMonth])

    useEffect(() => {
        let fullList = { ...sslcertificateList };

        const domainFilteredList = !!selectedDomainName
            ? Object.keys(sslcertificateList)
                .filter((key) => selectedDomainName.includes(key))
                .reduce((result, key) => {
                    result[key] = sslcertificateList[key];
                    return result;
                }, {})
            : fullList;

        const combinedFilteredList = !!selectedMonth
            ? Object.keys(domainFilteredList).reduce((result, key) => {
                const filteredItems = domainFilteredList[key].filter((item) => {
                    if (item.expiry) {
                        const expiryDate = new Date(item.expiry);
                        return expiryDate.getMonth() + 1 == selectedMonth;
                    }
                    return false;
                });
                if (filteredItems.length > 0) {
                    result[key] = filteredItems;
                }
                return result;
            }, {})
            : domainFilteredList;

        setFilteredSslCertificateList(combinedFilteredList);
    }, [selectedDomainName, selectedMonth, sslcertificateList]);

    useEffect(() => {
        getListOfsslCertificate();
    }, [])

    return (
        <div id='tabs'>
            {isLoader && <Loader />}
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/domaincertificate.svg"} alt="" />Domain Certificates</h2>
                </div>
                <div className="align-center d-flex d-inline-block justify-content-end w-50">
                    <div className="d-inline-block mr-2"><i id="domainCertificateRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
                        onClick={() => { getListOfsslCertificate(); }}></i>
                    </div>
                    <div className="d-inline-block float-end w-200 mr-2">
                        <select className="form-select inputborder w-100 font11" value={selectedMonth} onChange={(e) => { setSelectedMonth(e.target.value) }}>
                            <option value="">All</option>
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                    </div>
                    <div className="d-inline-block float-end w-200 mr-2">
                        <select className="form-select inputborder w-100 font11" value={selectedDomainName} onChange={(e) => { setSelectedDomainName(e.target.value) }}>
                            <option value="">All</option>
                            {(!!Object.keys(sslcertificateList) && Object.keys(sslcertificateList)?.length > 0) && Object.keys(sslcertificateList)?.map((item, index) => {
                                return (
                                    <option key={index} value={item}>{item}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            </div>
            {Object.keys(filteredSslCertificateList)?.length > 0 ? Object.entries(filteredSslCertificateList)?.map(([operatorId, groups]) => ({ operatorId, groups })).sort((a, b) => a.operatorId.localeCompare(b.operatorId)).map(({ operatorId, groups }) => {
                return (
                    <div className="thead-fixed">
                        <div className='font-13 font-bold ml-2'>{operatorId}</div>
                        <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc ">
                            <thead>
                                <tr className="thead-dard-bg">
                                    <th className="srn-width">Sr</th>
                                    <th className={`domain-width`}>Domain Name</th>
                                    <th className={``}>Expiry Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!!groups && groups?.map((item, index) => {
                                    const convertedDate = !!item?.expiry ? moment(item.expiry, 'YYYY-MM-DD HH:mm') : "";
                                    const fifteenDaysLater = moment().add(15, 'days');
                                    const isExpiringSoon = fifteenDaysLater.isAfter(convertedDate);
                                    return (
                                        <tr className={`${isExpiringSoon ? 'domain-red' : ''}`} key={`${index}_${item?.domain}`}>
                                            <td>{index + 1}</td>
                                            <td>{item?.domain}</td>
                                            <td>{!!convertedDate ? convertedDate.format('DD/MM/YYYY HH:mm') : ""}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                )
            }) : <NoDataError />}

        </div>
    )
}

export default DomainCertificate